module.exports = __webpack_public_path__ + "static/img/top4.6541d82.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/top4.png
// module id = yRbv
// module chunks = 23